var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { cn } from '@/lib/utils';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0', {
    variants: {
        variant: {
            primary: 'text-text-primary-foreground bg-accent hover:bg-accent/90',
            secondary: 'bg-surface-button-secondary hover:bg-surface-button-secondary-hover text-(--color-link)',
            outline: 'hover:bg-highlight-background border border-gray-200 text-accent dark:border-input',
            'outline-neutral': 'hover:bg-highlight-background border border-gray-200 text-foreground dark:border-input',
            ghost: 'text-surface-button-primary hover:bg-highlight-background',
            'ghost-neutral': 'text-foreground-muted hover:bg-highlight-background',
            link: 'hover:text-surface-button-primary text-foreground hover:underline',
            'link-secondary': 'text-foreground-muted hover:underline',
            destructive: 'bg-bg-destructive-soft hover:bg-surface-button-destructive focus-visible:ring-bg-destructive-soft text-destructive-foreground',
        },
        size: {
            sm: 'h-9 px-2 py-1.5',
            md: 'h-10 p-2',
            // In case of icon button, the size is the same as the icon size
            // So add padding to make the button whatever size you want
            icon: 'min-w-auto h-auto w-auto p-0.5',
        },
    },
    defaultVariants: {
        variant: 'primary',
        size: 'md',
    },
});
const Button = React.forwardRef((_a, ref) => {
    var { className, variant, size, asChild = false, isLoading = false } = _a, props = __rest(_a, ["className", "variant", "size", "asChild", "isLoading"]);
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, Object.assign({ className: cn('cursor-pointer disabled:pointer-events-none disabled:opacity-50', buttonVariants({ variant, size, className })), ref: ref }, props, { children: isLoading ? _jsx(LoadingIcon, {}) : props.children })));
});
Button.displayName = 'Button';
export { Button, buttonVariants };
